export const GET_EMSL_SUMMARY_COUNT = "emsl/summary/counts";
export const GET_EMSL_SUMMARY_ENGAGED_BRAND_EXPOSURE =
  "emsl/summary/brand-exposure";
export const GET_EMSL_SUMMARY_ENGAGED_UNIQUE_USERS =
  "emsl/summary/unique-users";
export const GET_EMSL_SUMMARY_ENGAGED_USER_LIST = "emsl/summary/user-list";
export const GET_EMSL_SUMMARY_CONSENTED_BRAND_EXPOSURE =
  "emsl/consented-emsl/brand-exposure";
export const GET_EMSL_SUMMARY_CONSENTED_UNIQUE_USERS =
  "emsl/consented-emsl/unique-users";
export const GET_EMSL_SUMMARY_CONSENTED_HCP_DETAILS = "emsl/summary/hcp-list";
export const GET_EMSL_SUMMARY_IN_DEMO_SCHEDULE_STATUS =
  "emsl/in-demo/schedule-status";
export const GET_EMSL_SUMMARY_IN_DEMO_MEDIUM_DEMO = "emsl/in-demo/medium-demo";
export const GET_EMSL_SUMMARY_IN_DEMO_GEOGRAPHY = "emsl/in-demo/geography-data";
export const GET_EMSL_SUMMARY_IN_DEMO_CALENDER = "emsl/in-demo/calendar-data";
export const GET_EMSL_SUMMARY_IN_DEMO_HCP_DETAILS = "emsl/summary/hcp-list";
export const GET_EMSL_SUMMARY_PRESCRIBERS_NPS_SCORE =
  "emsl/exp-prescribers/nps-data";
export const GET_EMSL_SUMMARY_PRESCRIBER_LBL_SENT =
  "emsl/exp-prescribers/lbl-sent-data";
export const GET_EMSL_SUMMARY_PRESCRIBERS_HCP_SCORE =
  "emsl/exp-prescribers/hcp-satisfaction-score";
export const GET_EMSL_SUMMARY_PRESCRIBERS_LBL_DOCUMENT =
  "emsl/exp-prescribers/lbl-documents-data";
export const GET_EMSL_SUMMARY_LEADS_USER_DETAILS = "emsl/lead-data";
export const GET_EMSL_SUMMARY_LEADS_USER_ENGAGEMENT = "emsl/lead-data";
export const GET_EMSL_PROJECT_DETAILS = "emsl/summary/details";
export const GET_LEAD_DATA_FILE = "emsl/lead-data-file";
export const GET_TEMPLATE_FETCH = "emsl/template-fetch";
